// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1UvlT","checkboxCol":"Table_checkboxCol__2Xy6e","emailCol":"Table_emailCol__F2D3b","actionCol":"Table_actionCol__B-n1T"};